import { useSubscriptionPlan } from 'hooks/Subscriptions';
import {
  isSubscriptionGrowMaxPlan,
  isSubscriptionProMaxPlan,
} from 'utils/subscriptions.utils';

const useIsMaxSubscriber = () => {
  const planInternalName = useSubscriptionPlan()?.planInternalName;

  const isPROMaxSubscriber = isSubscriptionProMaxPlan(planInternalName);
  const isGROWMaxSubscriber = isSubscriptionGrowMaxPlan(planInternalName);

  return isPROMaxSubscriber || isGROWMaxSubscriber;
};

export default useIsMaxSubscriber;
